export const languageChangerObject = {
    'russian': {
        'navigation': {
            0: '',
            1: 'Отзывы',
            2: 'О компании',
            3: 'Услуги',
            4: 'Контакты',
        },
        'previewPage': {
            1: 'AutoChip — Автоключи,',
            2: 'автоэлектрик, диагностика',
            3: 'Изготовление и ремонт автоключей, ремонт замков, установка регистратора, парктроника в Кишинёве',
            4: 'Рассказать о проблеме',
            //5:'100% Доверенный автосервис с локацией в Кишинёве!'//
        },
        'whyUs': {
            1: 'Почему стоит выбрать нас?',
            2: 'Приемлемые цены ',
            3: 'Квалифицированный персонал',
            4: 'Персональная гарантия',
            5: 'Используем для ремонта новые запчасти',
            6: 'Маршрут к автосервису',
            7: 'Отзывы клиентов',
            8: 'Смотреть все отзывы',
            9: "15+ лет опыта работы",
            10: "Квалифицированный персонал",
            11: "Качественные запчасти для ремонта",
            12: "Собственный склад запчастей",
        },
        'shortAdd': {
            1: 'Запишитесь на диагностику в AutoChip!',
            2: 'Перестал работать бесключевой доступ машины? Запишитесь к нам на диагностику!',
            3: 'Записаться',
        },
        'shortAdd2': {
            1: 'Удаление ошибок после аварии авто, от AutoChip!',
            2: 'Услуга «Crash data reset» — полное удаление ошибок на airbag, из памяти авто.',
            3: 'Связаться сейчас',
        },
        'aboutUs': {
            1: 'Об автосервисе',
            2: 'Auto Chip – эксперты в автомобильных ключах, замках и электронике!',
            9: 'Мы знаем, как важно всегда иметь доступ к своему автомобилю и обеспечивать его надежную работу. Наши мастера специализируются на изготовлении и ремонте ключей, восстановлении автомобильных замков, программировании иммобилайзеров и чип-тюнинге.',
            10: 'Наши мастера – профессионалы, которые найдут и устранят проблему быстро и качественно! Доверьте нам свою машину – мы знаем, как вернуть ей 100% функциональность!',
            11: 'Посмотрите наши работы:',
            12: 'Фото отчёты'
        },
        'contactsPage': {
            'form': {
                1: 'Или опишите вашу проблему и мы вам перезвоним',
                2: 'Ваш номер телефона*',
                3: 'Ваше имя',
                4: 'Евгений...',
                5: 'Укажите модель и год вашего авто',
                6: 'Toyota Camry, 2018 года...',
                7: 'Расскажите нам о вашей проблеме',
                8: 'Например: Не работает бесключевой доступ на машине...',
                9: 'Ваша заявка была успешна отправлена! Ожидайте ответа.',
                10: 'Отправить',
                11: '* Это поле обязательно для заполнения',
				details: 'Для детальной консультации, позвоните нам прямо сейчас!',
            },
            'contacts': {
                1: 'Контакты',
                2: 'г. Кишинёв, ул. Костюжень 14 (рядом с клиникой Familia)',
                3: 'Пн-Пт: 9:00 — 18:00, Сб: 9:00 — 14:00',
				requisites: 'Банковские реквизиты:'
            },
            'bank-details_header': {
                1: 'Rechizite bancare:',
                2: 'mun. Chisinau, str. Costiujeni 14',
                3: 'Lu-Vi: 8:30 — 18:00, Sâ: 9:00 — 14:00',
            },
            'form-info': {
                1: 'sss',
            },
        },
        'restorationLocale': {
            1: 'Чем мы занимаемся?',
        },
        'QALocale': {
            oftenAsked: 'Часто задаваемые вопросы',
            newRack: 'У меня сломался или потерялся авто ключ. Можете сделать новый?',
            newRackDescription: 'Да, мы занимаемся изготовлением (программированием) ключей, а так же предоставляем услуги по ремонту автомобильных ключей и замене изношенных корпусов.',
            signsOfBroken: 'Можно ли починить сломанный ключ или замок, или обязательно менять?',
            signsOfBrokenDescription: 'Возможность и целесообразность ремонта всегда зависит от многих факторов, таких как: марка, модель и год выпуска автомобиля, тип поломки, степень износа,  условия эксплуатации, а так же от ряда других индивидуальных особенностей конкретно Вашего случая, которые необходимо выяснить в процессе бесплатной консультации по телефону или иным доступным способом (через мессенджеры).',
            qaQuestion1: 'Что делать, если мой авто ключ не распознаётся автомобилем?',
            qaQuestion1Description: 'Если ваш ключ не распознаётся вашим автомобилем в первую очередь необходимо убедиться, что вы не взяли случайно ключ жены (мужа), друга или другого близкого человека (бывает и такое). Если ключ всё-таки действительно Ваш, но двигатель не запускается - не постесняйтесь позвонить, наш специалист в процессе общения попытается точно установить на каком этапе возникла проблема (которая может заключаться как в механической, так и в электронной составляющей ключа), а так же предложит подходящее решение.',
            qaQuestion2: 'Машина перестала заводиться. Может ли проблема быть в электрике?',
            qaQuestion2Description: 'Если машина перестала заводиться проблема может быть как в электрике, так и в механике. Причины могут быть самые разные.  Выяснение обстоятельств возникновения неисправности со слов клиента поможет сделать предварительные выводы  в чём может быть дело. Мы не занимаемся устранением механических дефектов двигателя, но можем выявить и устранить неисправности электрооборудования, включая диагностику датчиков и исполнительных механизмов.',
            qaQuestion3: 'Вы можете отремонтировать автомобильный замок?',
            qaQuestion3Description: 'Да, мы занимаемся разблокированием и ремонтом автомобильных замков (дверных и зажигания), включая поиск и устранение неисправностей в системе центральной блокировки дверей, электроприводов (активаторов) замков.',
            qaQuestion4: 'Сколько стоит диагностика не рабочего парктроника? Перестал обнаруживать препятствия',
            qaQuestion4Description: 'Система парковочного ассистента может быть реализована по-разному. От простых китайских дополнительно установленных до сложных заводских систем с интеллектуальными датчиками обнаружения препятствий. Фиксированной цены на диагностику не существует. Проблема может лежать на поверхности (например сломанный в результате удара датчик парковки), а может заключаться в неисправности проводки, монтажного блока, блока управления системой парковочный ассистент, а так же в системе вывода информации (дисплей, звуковой сигнал и др.) Примерная стоимость диагностики и ремонта, а так же план проверки обсуждаются в момент предварительного осмотра.',
            qaQuestion5: 'У вас можно установить парктроник?',
            qaQuestion5Description: 'Да, мы занимаемся установкой различного дополнительного оборудования на автомобиль, включая систему парктроника, видеорегистратор, дистанционное управление центральным замком, акустику (магнитолу, колонки, усилители, сабвуферы) и др.',
            qaQuestion6: 'Доп Вопрос 6',
            qaQuestion6Description: 'Доп 6 описание',
            qaQuestion7: 'Доп Вопрос 7',
            qaQuestion7Description: 'Доп 7 описание',
            qaQuestion8: 'Доп Вопрос 8',
            qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Сайт разработан при поддержке',
            2: ' при поддержке '
        }
    },
    'romanian': {
        'navigation': {
            0: '',
            1: 'Recenzii',
            2: 'Despre companie',
            3: 'Servicii',
            4: 'Contacte',
        },
        'previewPage': {
            1: 'AutoChip — Chei auto',
            2: 'electrician auto, diagnosticare',
            3: 'Fabricare și reparare chei auto, repararea lacătelor, instalare video registratoare, senzori parcare în Chișinău',
            4: 'Descrie-ne problema ta',
            //5:'service auto de Încredere cu locație în Chișinău!'
        },
        'whyUs': {
            1: 'De ce trebuie să ne alegi?',
            2: 'Prețuri rezonabile',
            3: '-',
            4: 'Personal calificat',
            5: 'Piese de schimb calitative',
            6: 'Vezi locația',
            7: 'Recenziile clienților',
            8: 'Toate recenziile',
            9: "15+ ani de experiență",
            10: "Personal calificat",
            11: "Piese de schimb calitative",
            12: "Propriu depozit de piese",
        },
        'shortAdd': {
            1: "Programează-te pentru o verificare la Auto Chip!",
            2: "Sistemul de acces fără cheie al mașinii nu mai funcționează? Programează-te la noi pentru o verificare!",
            3: "Programează-te",
        },
        'shortAdd2': {
            1: "Eliminarea erorilor după un accident auto, de la Auto Chip!",
            2: "Serviciul „Crash Data Reset” – ștergerea completă a erorilor airbag din memoria mașinii.",
            3: "Contactează-ne acum",
        },
        'aboutUs': {
            1: 'Despre autoservice',
            2: "Auto Chip – experți în chei auto, încuietori și electronică auto!",
            9: "Știm cât de important este să ai mereu acces la mașina ta și să îi asiguri funcționarea fiabilă. Meșterii noștri sunt specializați în fabricarea și repararea cheilor, restaurarea încuietorilor auto, programarea imobilizatoarelor și chip-tuning.",
            10: "Meșterii noștri sunt profesioniști care vor găsi și remedia problema rapid și eficient! Încredințează-ne mașina ta – știm cum să îi redăm 100% funcționalitatea!",
            11: 'Vezi lucrările noastre:',
            12: 'Foto raporturi',
        },
        'contactsPage': {
            'form': {
                1: 'Sau descrie-ne problema ta și te sunăm înapoi',
                2: 'Telefonul tău*',
                3: 'Nume',
                4: 'Eugen',
                5: 'Modelul și anul automobilului',
                6: 'Toyota Camry, anul 2018 ',
                7: 'Descrie-ne problema ta',
                8: 'Exemplu: La mașină nu se mai încuie ușile de la cheie...',
                9: 'Cererea ta a fost trimisă cu succes! Așteaptă un sunet',
                10: 'Trimite',
                11: '* Este necesar să completezi măcar acest câmp',
				details: 'Pentru o consultanță detaliată, sunați-ne chiar acum!',
            },
            'contacts': {
                1: 'Contacte',
                2: 'mun. Chisinau, str. Costiujeni 14 (alături de clinica Familia)',
                3: 'Lu-Vi: 8:30 — 18:00, Sâ: 9:00 — 14:00',
				requisites: 'Datele bancare:'
            },
            'bank-details': {
                1: 'Rechizite bancare:',
                2: 'mun. Chisinau, str. Costiujeni 14 (alături de clinica Familia)',
                3: 'Lu-Vi: 8:30 — 18:00',
            },
            'form-info': {
                1: 'sss',
            }
        },
        'restorationLocale': {
            1: 'Ce lucrări efectuăm?',
        },
        'QALocale': {
            oftenAsked: 'Întrebări frecvente',
            newRack: 'Mi-am pierdut sau mi s-a stricat cheia auto. Puteți face una nouă?',
            newRackDescription: 'Da, ne ocupăm cu fabricarea (programarea) cheilor și oferim, de asemenea, servicii de reparație a cheilor auto și înlocuire a carcaselor uzate.',
            signsOfBroken: 'Se poate repara o cheie sau o încuietoare defectă, sau trebuie neapărat înlocuită?',
            signsOfBrokenDescription: 'Posibilitatea și oportunitatea reparației depind întotdeauna de mulți factori, cum ar fi: marca, modelul și anul de fabricație al automobilului, tipul defecțiunii, gradul de uzură, condițiile de exploatare, precum și alți factori individuali specifici cazului dumneavoastră. Aceste aspecte trebuie clarificate în timpul unei consultații gratuite prin telefon sau prin orice alt mijloc de comunicare disponibil (de exemplu, mesagerii).',
            qaQuestion1: 'Ce să fac dacă mașina mea nu recunoaște cheia auto?',
            qaQuestion1Description: 'Dacă cheia nu este recunoscută de automobilul dumneavoastră, în primul rând, trebuie să vă asigurați că nu ați luat din greșeală cheia soției, soțului, unui prieten sau unui coleg (se întâmplă destul de des). Dacă este cu adevărat cheia dumneavoastră, dar motorul nu pornește, nu ezitați să ne contactați. Specialistul nostru va determina în ce etapă apare problema (care poate fi atât mecanică, cât și electronică) și vă va propune o soluție potrivită.',
            qaQuestion2: 'Mașina nu mai pornește. Problema poate fi de natură electrică?',
            qaQuestion2Description: 'Dacă mașina nu mai pornește, problema poate fi atât electrică, cât și mecanică. Cauzele pot fi diverse. Stabilirea exactă a defecțiunii împreună cu clientul poate ajuta la identificarea problemei. Nu reparăm defectele mecanice ale motorului, dar putem identifica și remedia defecțiunile echipamentului electric, inclusiv defecțiunile senzorilor și mecanismelor de execuție.',
            qaQuestion3: 'Puteți debloca o lacătul auto?',
            qaQuestion3Description: 'Da, ne ocupăm cu deblocarea și repararea încuietorilor auto (de la uși și de la contact), inclusiv detectarea și remedierea defecțiunilor sistemului de blocare centralizată a ușilor, a încuietorilor electrice (actuatoare).',
            qaQuestion4: 'Cât costă diagnosticul unui senzor de parcare defect? Nu mai detectează obstacolele',
            qaQuestion4Description: 'Sistemele de parcare pot varia de la modele simple chinezești suplimentare la sisteme complexe instalate din fabrică, cu algoritmi de autodiagnosticare. Din acest motiv, nu există un preț fix pentru diagnosticare. Problema poate fi la suprafață (de exemplu, un senzor spart în urma unui impact la parcare) sau poate fi legată de cablaj, blocul de control al sistemului de parcare sau alte componente (display, semnal sonor etc.). Prețul diagnosticului și al reparației, precum și soluțiile posibile, sunt discutate în timpul unei inspecții preliminare.',
            qaQuestion5: 'Puteți instala senzori de parcare?',
            qaQuestion5Description: 'Da, instalăm diverse echipamente electronice pentru automobile, inclusiv senzori de parcare, camere video pentru parcare, sisteme de monitorizare a unghiurilor moarte, sisteme multimedia, amplificatoare, subwoofere etc.',
            qaQuestion6: 'Доп Вопрос 6',
            qaQuestion6Description: 'Доп 6 описание',
            qaQuestion7: 'Доп Вопрос 7',
            qaQuestion7Description: 'Доп 7 описание',
            qaQuestion8: 'Доп Вопрос 8',
            qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Site-ul a fost dezvoltat de către',
            2: " cu suportul "
        }
    }
}